import React, { useEffect, useState } from 'react';
import { API_URL } from '../../Config';
import './statsData.css'

function StatsData({ transactions }) {
    const [allTransactions, setAllTransactions] = useState(null);
  
    useEffect(() => {
      fetch(`${API_URL}/data`)
        .then(res => res.json())
        .then(data => setAllTransactions(data.data))
        .catch(error => console.error(error));
    }, []);

    const tA = allTransactions ? allTransactions.reduce((ttl, trn) => ttl + trn.amount, 0) : 0;
    const tDb= allTransactions ? allTransactions.reduce((ttl, trn) => ttl + (trn.type === 1 ? trn.amount : 0), 0) : 0;
    const tDp = allTransactions ? allTransactions.reduce((ttl, trn) => ttl + (trn.type === 2 ? trn.amount : 0), 0) : 0;
    const dbC = allTransactions ? allTransactions.filter(trn => trn.type === 1).length : 0;
    const dpC = allTransactions ? allTransactions.filter(trn => trn.type === 2).length : 0;
    
    const totalAmount = transactions.length > 0 ? transactions.reduce((total, transaction) => total + transaction.amount, 0) : tA;
    const totalDebit = transactions.length > 0 ? transactions.reduce((total, transaction) => total + (transaction.type === 1 ? transaction.amount : 0), 0) : tDb;
    const totalDeposit = transactions.length > 0 ? transactions.reduce((total, transaction) => total + (transaction.type === 2 ? transaction.amount : 0), 0) : tDp;
    const debitCount = transactions.length > 0 ? transactions.filter(transaction => transaction.type === 1).length : dbC;
    const depositCount = transactions.length > 0 ? transactions.filter(transaction => transaction.type === 2).length : dpC;
    
  return (
    <div className="stats-data">
      <div className="stats-data-container">
        <div className="stats-left-data">
          <p>Total transactions amount: <span>{totalAmount}</span></p>
          <p>Total amount debited: <span>{totalDebit}</span></p>
          <p>Total amount deposited: <span>{totalDeposit}</span></p>
        </div>
        <div className="stats-right-data">
          <p>Total number of debit transactions: <span>{debitCount}</span></p>
          <p>Total number of deposit transactions: <span>{depositCount}</span></p>
        </div>
      </div>
    </div>
  );
}

export default StatsData;
